module.exports = __webpack_public_path__ + "imgs/pinterest-color.0a860f5fb74c83fef23f593c7ecf8951.svg";